// Villager breeding (MB.7). PURE (ENG-1). Villagers breed when both partners are
// "willing" (fed enough food) AND the village has a spare bed. Willingness is a
// food-point budget: bread is worth a lot, root vegetables a little (Java's 3
// bread / 12 carrot-potato-beetroot rule). The host tracks each villager's points
// and the bed census; this owns the pure thresholds + the breed decision.

/** Food points each breeding food is worth per unit (Java-faithful ratio). */
export const BREED_FOOD_POINTS: Readonly<Record<string, number>> = {
  bread: 4, carrot: 1, potato: 1, beetroot: 1,
};

/** Points needed before a villager is willing to breed (3 bread / 12 veg). */
export const WILLING_THRESHOLD = 12;

/** Points a stack of `item` contributes (0 for non-breeding foods). */
export function foodPoints(item: string, count = 1): number {
  return (BREED_FOOD_POINTS[item] ?? 0) * Math.max(0, count);
}

/** Whether an item counts as villager breeding food. */
export function isBreedFood(item: string): boolean {
  return item in BREED_FOOD_POINTS;
}

/** A villager with at least the threshold of food points is willing. */
export function isWilling(points: number): boolean {
  return points >= WILLING_THRESHOLD;
}

/**
 * Whether a pair may breed now: both willing, and the local bed census has a free
 * bed for the child (Java: beds must outnumber villagers in range).
 */
export function canBreed(pointsA: number, pointsB: number, beds: number, villagers: number): boolean {
  return isWilling(pointsA) && isWilling(pointsB) && beds > villagers;
}
